import React from 'react';
import { useTranslation } from 'react-i18next';
import { S, Icon, Icons, BtnPrimary, BtnSecondary} from '../regureStyles';
import PermissionGate from '../../components/PermissionGate';
import GenerateAllButton from './GenerateAllButton';

const Header = ({ setShowNew, offers, total, convRate, filters, selectedIds, onExported }) => {
  const { t } = useTranslation();
  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
          {t('offers.list.breadcrumbOps')} {Icons.chevronRight(S.textMuted, 12)} <span style={{ color: S.textPrimary, fontWeight: 500 }}>{t('offers.list.breadcrumbCurrent')}</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 700, color: S.textPrimary }}>{t('offers.list.pageTitle')}</div>
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <div
          style={{
            display: 'flex',
            gap: 16,
            alignItems: 'center',
            padding: '8px 16px',
            background: S.bgCard,
            border: `1px solid ${S.borderLight}`,
            borderRadius: 10,
            marginRight: 4,
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 18, fontWeight: 700, color: S.textPrimary }}>{total}</div>
            <div style={{ fontSize: 10, color: S.textMuted, fontWeight: 600, textTransform: 'uppercase' }}>{t('offers.list.kpiTotal')}</div>
          </div>
          <div style={{ width: 1, height: 28, background: S.borderLight }} />
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#10b981' }}>{convRate}%</div>
            <div style={{ fontSize: 10, color: S.textMuted, fontWeight: 600, textTransform: 'uppercase' }}>{t('offers.list.kpiConversion')}</div>
          </div>
        </div>
        <PermissionGate resource='offers' action='create'>
          <BtnPrimary onClick={() => setShowNew(true)}>
            <Icon name='plus' color='#fff' size={16} /> {t('offers.list.newQuote')}
          </BtnPrimary>
        </PermissionGate>
        <BtnSecondary
          onClick={() => {
            const headers = [
              t('offers.list.colOfferNumber'),
              t('offers.list.colClient'),
              t('offers.list.colProduct'),
              t('offers.list.colStatus'),
              t('offers.list.colPremium'),
              t('rateTables.currency'),
              t('offers.list.colExpires'),
            ];
            const rows = offers.map(o => [o.id, o.client, o.product, o.status, o.premiumCalc, o.currency || 'CHF', o.expires || '']);
            const csv = [headers, ...rows].map(r => r.map(v => `"${String(v || '').replace(/"/g, '""')}"`).join(',')).join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `offers-${new Date().toISOString().slice(0, 10)}.csv`;
            a.click();
            URL.revokeObjectURL(url);
          }}
        >
          <Icon name='download' color={S.textMuted} size={15} /> {t('offers.list.export')}
        </BtnSecondary>
        {/* Beside the CSV export, because both answer "give me this list as
            files" — one as a spreadsheet, one as the actual proposals. */}
        <GenerateAllButton filters={filters} total={total} selectedIds={selectedIds} onExported={onExported} />
        {/* The inbound counterpart of the two exports above. Gated on
            offers.create, so a read-only broker sees the exports and not this. */}
        <PermissionGate resource='offers' action='create'>
          <BtnSecondary onClick={() => { window.location.hash = '#/offers/import'; }}>
            <Icon name='upload' color={S.textMuted} size={15} /> {t('offers.list.bookImport')}
          </BtnSecondary>
        </PermissionGate>
      </div>
    </header>
  );
};

export default Header;
